"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSelectOptions = function (type, options) {
    return type === 'select' && Array.isArray(options) ? options : undefined;
};
exports.default = getSelectOptions;
//# sourceMappingURL=getSelectOptions.js.map